import React, { useEffect, useState } from "react";
import ticket1 from "../../assets/company-logo/ticket1.jpg";
import ticket2 from "../../assets/company-logo/ticket2.jpg";
import ticket3 from "../../assets/company-logo/ticket3.jpg";
import toast, { Toaster } from "react-hot-toast";
import { IoCloseOutline } from "react-icons/io5";
import {
  FaHotel,
  FaUtensils,
  FaSwimmingPool,
  FaTags,
  FaStar,
  FaCheck,
  FaTrophy,
  FaSmile,
  FaPlane,
  FaPercentage,
  FaGift,
} from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { postApi } from "../../services/apiController";
import { useSelector } from "react-redux";
import AOS from "aos";
import Slider from "react-slick";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OrderPopup = ({ orderPopup, setOrderPopup }) => {
  const theme = useSelector((state) => state.theme.theme); // Assuming 'currentTheme' holds 'dark' or 'light'
  const [loading, setLoading] = useState(false); // State for the loader
  const themeClasses =
    theme === "dark" ? "bg-black text-white" : "bg-white text-gray-900";

  // Check if the user has seen the popup before
  const checkFirstVisit = () => {
    const popupShown = localStorage.getItem("popupShown");
    if (!popupShown) {
      localStorage.setItem("popupShown", "true");
      return true;
    }
    return false;
  };

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    AOS.init();
    AOS.refresh();

    // Delay the popup appearance by 3-4 seconds
    const timer = setTimeout(() => {
      if (checkFirstVisit()) {
        setShowPopup(true);
      }
    }, 3000); // 3000 ms = 3 seconds

    // Clean up the timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  // Validation schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    mob_no: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
    date: Yup.date().required("Date is required").nullable(),
    destination: Yup.string()
      .min(3, "Destination must be at least 3 characters")
      .required("Destination is required"),
  });

  // Initial form values
  const initialValues = {
    name: "",
    email: "",
    mob_no: "",
    date: "",
    destination: "",
  };

  // Submit handler
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formattedValues = {
        ...values,
        date: dayjs(values.date).format("DD/MM/YYYY"), // Format date here
      };
      const res = await postApi("postQuery", formattedValues);
      toast(res.message);
      setOrderPopup(false);
    } catch (error) {
      console.log(error, "error");
      setLoading(false);
      toast(res.message);
    } finally {
      setLoading(false);
    }
  };

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };
  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <>
      {(showPopup || orderPopup) && (
        <div
          data-aos="flip-up"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          className="h-screen w-screen fixed top-0 left-0 bg-black/50 z-50 backdrop-blur-sm flex justify-center items-center"
        >
          <div
            className={`bg-white relative dark:bg-gray-900 dark:text-white rounded-lg shadow-lg p-6 w-[90%] max-w-[900px] flex ${themeClasses}`}
          >
            {/* Left Side */}
            <div className="md:w-1/2 md:flex hidden flex-col p-2 relative z-10">
              <Slider {...settings}>
                <div className="relative">
                  <FaTags
                    size={20}
                    className="text-yellow-400 absolute top-0 left-0"
                  />
                  <img
                    src={ticket1}
                    alt="Winter Sale"
                    className="rounded-lg shadow-md"
                  />
                </div>
                <div className="relative">
                  <FaTags
                    size={20}
                    className="text-yellow-400 absolute top-0 left-0"
                  />
                  <img
                    src={ticket2}
                    alt="Summer Sale"
                    className="rounded-lg shadow-md"
                  />
                </div>
                <div className="relative">
                  <FaTags
                    size={20}
                    className="text-yellow-400 absolute top-0 left-0"
                  />
                  <img
                    src={ticket3}
                    alt="Summer Sale offer"
                    className="rounded-lg shadow-md"
                  />
                </div>
                {/* Add more slides as needed */}
              </Slider>
              <div className="mt-4 space-y-4 text-indigo-600">
                <div className="flex items-center">
                  <FaStar size={30} className="mr-2 text-yellow-400" />
                  <div>4.4+ Rating with more than 1.6k reviews</div>
                </div>
                <div className="flex items-center">
                  <FaCheck size={30} className="mr-2 text-green-400" />
                  <div>Best Service with more than 300+ experts</div>
                </div>
                <div className="flex items-center">
                  <FaTrophy size={30} className="mr-2 text-yellow-400" />
                  <div>12+ years of travel management experience</div>
                </div>
                <div className="flex items-center">
                  <FaSmile size={30} className="mr-2 text-yellow-400" />
                  <div>We have more than 50k+ Happy Customers</div>
                </div>
                <div className="flex items-center">
                  <FaPlane size={30} className="mr-2 text-blue-400" />
                  <div>We have more than 500+ Trips and Tours</div>
                </div>
              </div>
              <div className="text-center mt-6 text-indigo-600">
                <p>Connect with us for best offers and deals</p>
                <p className="text-lg font-semibold">+91-7742386069</p>
              </div>
            </div>
            {/* Right Side */}
            <div className="md:w-1/2 w-full p-4 bg-gradient-to-r from-indigo-500 to-indigo-700 rounded-lg shadow-inner">
              <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold text-white">
                  Hurry! Get Best Deals On Travel
                </h1>
                <IoCloseOutline
                  className="text-3xl absolute top-0 right-0 cursor-pointer dark:text-white text-black hover:text-gray-500"
                  onClick={() => {
                    setOrderPopup(false);
                    setShowPopup(false);
                  }} // Close the popup
                />
              </div>
              <div className="text-center">
                <Slider {...settings2}>
                  <div className="flex flex-col justify-center items-center">
                    <h2 className="text-3xl font-bold text-yellow-300">
                      Christmas Sale
                    </h2>
                    <p className="text-lg text-white">Upto 40% Discount</p>
                  </div>
                  <div className="flex flex-col justify-center items-center">
                    <h2 className="text-3xl font-bold text-yellow-300">
                      Winter Sale
                    </h2>
                    <p className="text-lg text-white">25% Discount</p>
                  </div>
                  <div className="flex flex-col justify-center items-center">
                    <h2 className="text-3xl font-bold text-yellow-300">
                      New Year Sale
                    </h2>
                    <p className="text-lg text-white">35% Discount</p>
                  </div>
                </Slider>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty }) => (
                  <Form className="space-y-4">
                    {/* Name Field */}
                    <div>
                      <label htmlFor="name" className="sr-only">
                        Name
                      </label>
                      <Field
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Enter Your Name"
                        className="w-full rounded-full border border-gray-300 dark:border-gray-500 dark:bg-gray-800 px-4 py-2 shadow-md"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    {/* Email Field */}
                    <div>
                      <label htmlFor="email" className="sr-only">
                        Email
                      </label>
                      <Field
                        id="email"
                        type="email"
                        name="email"
                        placeholder="Enter Your Email Address"
                        className="w-full rounded-full border border-gray-300 dark:border-gray-500 dark:bg-gray-800 px-4 py-2 shadow-md"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    {/* Mobile Number Field */}
                    <div>
                      <label htmlFor="mob_no" className="sr-only">
                        Mobile Number
                      </label>
                      <Field
                        id="mob_no"
                        type="text"
                        name="mob_no"
                        placeholder="Enter Mobile Number"
                        className="w-full rounded-full border border-gray-300 dark:border-gray-500 dark:bg-gray-800 px-4 py-2 shadow-md"
                      />
                      <ErrorMessage
                        name="mob_no"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    {/* Date Field */}
                    <div>
                      <label htmlFor="date" className="sr-only">
                        Date
                      </label>
                      <Field
                        id="date"
                        type="date"
                        name="date"
                        className="w-full rounded-full border border-gray-300 dark:border-gray-500 dark:bg-gray-800 px-4 py-2 shadow-md"
                      />
                      <ErrorMessage
                        name="date"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    {/* Destination Field */}
                    <div>
                      <label htmlFor="destination" className="sr-only">
                        Destination
                      </label>
                      <Field
                        id="destination"
                        type="text"
                        name="destination"
                        placeholder="Enter Destination"
                        className="w-full rounded-full border border-gray-300 dark:border-gray-500 dark:bg-gray-800 px-4 py-2 shadow-md"
                      />
                      <ErrorMessage
                        name="destination"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    {/* Submit Button */}
                    <div className="mt-4">
                      <button
                        type="submit"
                        className={`w-full py-3 rounded-full text-lg bg-gradient-to-r from-yellow-500 to-red-800 hover:from-yellow-600 text-white flex justify-center items-center transform transition-all duration-300 ease-in-out shadow-lg hover:shadow-xl active:shadow-sm active:translate-y-1`}
                        disabled={!dirty || !isValid}
                      >
                        {loading ? (
                          <div className="flex items-center space-x-2">
                            <svg
                              className="w-5 h-5 animate-spin text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0l-3.17 3.17A8.01 8.01 0 004 12z"
                              ></path>
                            </svg>
                            <span>Processing...</span>
                          </div>
                        ) : (
                          "Get Best Offers"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
      <Toaster />
    </>
  );
};

export default OrderPopup;
